import {CONFIG_BY_ENV} from '@/utils/constant';
import {getEnvironmentFromCookie} from '@/utils/getEnvironmentFromCookie';
import {SKZEnvironment, SKZEnvironmentValue} from '@/utils/SKZEnvironment.types';

/**
 * Returns the service configuration object based on the current environment.
 * Defaults to STAGING if the environment is not recognized or not provided.
 */
export function getEnvConfig(): Record<string, string> {
  const rawEnv = process.env.ENVIRONMENT || getEnvironmentFromCookie();
  const env = (rawEnv as SKZEnvironmentValue) || SKZEnvironment.PRODUCTION;

  if (!CONFIG_BY_ENV[env]) {
    console.warn(`No config found for environment: ${rawEnv}, falling back to STAGING`);
    return CONFIG_BY_ENV[SKZEnvironment.STAGING];
  }

  return CONFIG_BY_ENV[env];
}
